import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';


export interface Config {
  azureUrl: string;
  containerUrl: string;
  dartHost: string;
  directUrl: string;
  productionUrl: string;
  projectUrl: string;
  travelUrl: string;
  custom1Url: string;
  ppServiceUrl: string;
  transactionUrl: string;
  articleUrl: string;
  adminUrl: string;
  monitorUrl: string;
  wmsUrl: string;
  timeUrl: string;
  employeeUrl: string;
  basicUrl: string;
  purchaseUrl: string;
  absenceUrl: string;
  personnelUrl: string;
  dataWarehouseUrl: string;
  logUrl: string;
  systemAdminUrl: string;
  systemLogUrl: string;
  priceHandlingUrl: string;
  trackingUrl: string;
  oeeUrl: string;
  assignmentUrl: string;
  customerUrl: string;
  reportUrl: string;
  masterUrl: string;
  deviationUrl: string;
  mesUrl: string;
  documentUrl: string;
  ekornesUrl: string;

  transportRouteUploadMethod: string;
  planningEngineUrl: string;
  AzureAuthApiKey: string;
}

export interface Version {
  directVersion: string;
  isd24: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  config: Config;
  configUrl = 'assets/config.json';
  version: Version;
  versionUrl = 'assets/version.json';

  constructor(private http: HttpClient) {
    // this.getConfig()
    //   // clone the data object, using its known Config shape
    //   .subscribe((data: Config) => this.config = { ...data });
      this.getConfig().subscribe((data: any) => { // success path

        this.config = { ...data }
      }, error => { // error path;
      });
    this.getVersion()
      // clone the data object, using its known Version shape
      .subscribe((data: Version) => this.version = { ...data });
  }

  getConfig() {

    return this.http.get<Config>(this.configUrl)
      .pipe(
        catchError(this.handleError)
      );
  }

  getVersion() {
    return this.http.get<Version>(this.versionUrl)
      .pipe(
      catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

}
